// pulled from All-inclusive

export function useAsyncDataError(error: Ref<Error | null>, page: string) {
  if (!error.value) return;

  throw createError({ data: { error, page }, fatal: true });
}
